import { useEffect, useState } from 'react';

const COMPACT_QUERY = "(max-width: 767px)";

function readIsCompact(): boolean {
  if (typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(COMPACT_QUERY).matches;
}

/**
 * Tailwind's `md` breakpoint, answered in React rather than in CSS. Needed
 * where a class cannot help: a control that moves between two parents has to
 * be rendered in one of them, and rendering it in both would put two copies of
 * a stateful button in the tree.
 */
export default function useIsCompactViewport(): boolean {
  const [isCompact, setIsCompact] = useState<boolean>(readIsCompact);

  useEffect(function trackViewport() {
    if (typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const matchCompact = window.matchMedia(COMPACT_QUERY);
    const onChange = () => setIsCompact(matchCompact.matches);

    onChange();
    matchCompact.addEventListener('change', onChange);

    return () => matchCompact.removeEventListener('change', onChange);
  }, []);

  return isCompact;
}
